import { useMemo } from "react";
import { useService as useBaseService } from "./Base";
import { Service as ResourceService } from "./Resources";
import { IntegrationsPayload } from "../context/Integrations";

interface CreateParams {
    firstName: string;
    lastName: string;
    email: string;
    password?: string;
}

export class Service extends ResourceService {
    async create(params: CreateParams) {
        return await this.base.fetchAPI<CreateParams>(`/${this.route}/signup`, {
            method: "POST",
            body: params,
        });
    }

    async getIntegrations() {
        return await this.base.fetchAPI<IntegrationsPayload>(
            `/${this.route}/me/integrations`,
            {
                method: "GET",
            },
        );
    }
}

export const useService = () => {
    const base = useBaseService();

    return useMemo(() => new Service(base, "users"), [base]);
};
